import Vue from 'vue';

// When the request succeeds
const success = (response, resolve) => {
  resolve(response);
};

// When the request fails
const failed = (error, reject) => {
  reject(error);
};

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.post('wordpress/generate_token')
    .then((response) => {
      success(response.data.data, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/account/wordpressGenerateToken.js